import { defineComponent as _defineComponent } from 'vue'
import Modal from "../Modal.vue";
  import FilterHouses from "@/components/builder/budget-houses/FilterHouses.vue";
  import { BorrowCalculatorResult } from "@/types/BorrowCalculator";
  import { LotInterface } from "@/types/LotInterface";
  import { BuilderQuote } from "@/types/BuilderQuote";
  import {
    HouseDesignInterface,
    HouseLotsBuilderPagination,
  } from "@/types/HouseDesignInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderFiltersHousesModal',
  props: {
    isOpen: { type: Boolean },
    result: {},
    lotSelected: {},
    quote: {},
    houseDetailsView: { type: Boolean },
    isModalFiltersHousesHidden: { type: Boolean },
    hasToLoadNextBatch: { type: Boolean }
  },
  emits: [
    "close",
    "housesByFilter",
    "updateHousesPagination",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const onUpdateHousesPagination = (
    housesPagination: HouseLotsBuilderPagination
  ) => {
    emits("updateHousesPagination", housesPagination);
  };

  const onClose = () => {
    emits("close");
  };

  const onHousesByFilter = (houses: HouseDesignInterface[]) => {
    emits("housesByFilter", houses);
  };

  const onSearch = () => {
    emits("close");
  };

const __returned__ = { props, emits, onUpdateHousesPagination, onClose, onHousesByFilter, onSearch, Modal, FilterHouses, get BorrowCalculatorResult() { return BorrowCalculatorResult }, get LotInterface() { return LotInterface }, get BuilderQuote() { return BuilderQuote }, get HouseDesignInterface() { return HouseDesignInterface }, get HouseLotsBuilderPagination() { return HouseLotsBuilderPagination } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})